import { render, staticRenderFns } from "./setting_menu.vue?vue&type=template&id=a9ab609e&"
import script from "./setting_menu.vue?vue&type=script&lang=js&"
export * from "./setting_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports